import { logger } from '../utils/logger';
import api from '../api/api';
import { PersonalHabilitacion } from '../types/PersonalHabilitacion';

export class PersonalHabilitacionContratistaService {

  // CU13 (mantis 0200062): obtiene el personal de la habilitación más reciente APROBADA del contratista,
  // filtrado por situación contractual (PROPIO / SUBCONTRATADO / AUTONOMO).
  // Lista vacía si el contratista no tiene habilitación Aprobada.
  static async findHabilitadoParaSolicitud(
    idContratista: number,
    situacionContractual: string
  ): Promise<PersonalHabilitacion[]> {
    try {
      const response = await api.get(
        `/personal-habilitacion/habilitado-por-solicitud`,
        { params: { idContratista, situacionContractual } }
      );
      return response.data;
    } catch (error: any) {
      logger.error(
        'Error al cargar personal habilitado para solicitud:',
        error
      );
      throw error;
    }
  }

  // CU13 (mantis 0200062): situaciones contractuales (PROPIO / SUBCONTRATADO / AUTONOMO) en que
  // una persona (por tipo + nro de documento) está habilitada para el contratista (habilitaciones
  // APROBADA). Lista vacía si la persona no pertenece a la habilitación del contratista.
  static async findSituacionesHabilitado(
    idContratista: number,
    idTipoDocPersona: number,
    nroDocumento: string
  ): Promise<string[]> {
    const response = await api.get(
      `/personal-habilitacion/situaciones-habilitado`,
      { params: { idContratista, idTipoDocPersona, nroDocumento } }
    );
    return response.data;
  }
}
